export default function LearningsSidebar({ themes = [], commits = [], quote = "" }) {
  return (
    <aside className="rtv2-learn-side">
      <div className="rtv2-side-card">
        <div className="hd"><span>Themes</span><b>{themes.length} strands</b></div>
        <div className="bd">
          {themes.map((t) => (
            <div key={t.label} className="rtv2-theme"><span>{t.label}</span><b>×{t.count}</b></div>
          ))}
        </div>
      </div>

      <div className="rtv2-side-card">
        <div className="hd"><span>Carry into Q2</span><b>{commits.length} commits</b></div>
        <div className="bd">
          {commits.map((c, idx) => (
            <div key={`${c.text}-${idx}`} className={`rtv2-commit ${c.status}`}>
              <span className="chk" />
              <div className="txt"><b>{c.text}</b><small>{c.meta}</small></div>
            </div>
          ))}
        </div>
      </div>

      <div className="rtv2-quote">{quote}</div>
    </aside>
  );
}
